module.exports = __webpack_public_path__ + "img/demo.4514da6f.png";